export default __webpack_public_path__ + "static/media/plain-sticker-m.d08e4f10.png";